const EXPIRY_DAYS = 30;
const DEFAULT_RELEASE_DATE = '2026-04-14';

export const isDismissed = (dismissKey: string, releaseDate: string = DEFAULT_RELEASE_DATE): boolean => {
  const stored = localStorage.getItem(dismissKey);
  if (stored) {return true;}

  const release = new Date(releaseDate);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - release.getTime()) / (1000 * 60 * 60 * 24));
  return diffDays >= EXPIRY_DAYS;
};

export const dismiss = (dismissKey: string): void => {
  localStorage.setItem(dismissKey, 'true');
};
